import { inject } from "@angular/core";
import { CanDeactivateFn } from "@angular/router";
import { Observable } from "rxjs";
import { UnsavedChangesService } from "../services/unsaved-changes.service";

export interface CanComponentDeactivate {
  hasUnsavedChanges: () => boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (component): boolean | Observable<boolean> =>
  component?.hasUnsavedChanges?.() ? inject(UnsavedChangesService).confirmLeave() : true;
